import gql from "graphql-tag";

const getAllEmployee = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $departmentIds: [ID!]
    $exceptIds: [ID!]
    $positionId: ID
    $branchLocationId: ID
  ) {
    getAllEmployee(
      paging: { limit: $limit, page: $page }
      query: $query
      filter: {
        departmentIds: $departmentIds
        exceptIds: $exceptIds
        positionId: $positionId
        branchLocationId: $branchLocationId
      }
    ) {
      id
      code
      email
      fullname
      startedDate

      position {
        id
        name
      }
      department {
        id
        name
      }
      branchLocation {
        id
        name
      }
    }
  }
`;

const getAllEmployeeForWorkLeave = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $departmentIds: [ID!]
    $exceptIds: [ID!]
    $positionId: ID
    $branchLocationId: ID
  ) {
    getAllEmployee(
      paging: { limit: $limit, page: $page }
      query: $query
      filter: {
        departmentIds: $departmentIds
        exceptIds: $exceptIds
        positionId: $positionId
        branchLocationId: $branchLocationId
      }
    ) {
      id
      code
      email
      fullname
      startedDate
      departmentId
      positionId

      position {
        id
        name
      }
      department {
        id
        name
      }
      branchLocation {
        id
        name
        mainShift {
          id
        }
      }

      annualLeaveDay {
        default
        remain
        usedInYear
        original
      }
    }
  }
`;

export default { getAllEmployee, getAllEmployeeForWorkLeave };
